<template>
  <sui-form-field v-if="!field.hidden">
    <sui-table compact celled size="small" :color="color">
      <sui-table-header>
        <sui-table-row>
          <sui-table-header-cell :width="6">Name</sui-table-header-cell>
          <sui-table-header-cell :width="10">Value</sui-table-header-cell>
          <sui-table-header-cell collapsing />
        </sui-table-row>
      </sui-table-header>
      <sui-table-body v-if="!$attrs.value.length && !field.readonlyVariables">
        <sui-table-row>
          <sui-table-cell colspan="3">
            No variables
          </sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-body v-if="field.readonlyVariables">
        <sui-table-row v-for="(variable, index) in field.readonlyVariables" :key="index">
          <sui-table-cell>
            <input readonly v-model="variable.name" tabindex="-1" />
          </sui-table-cell>
          <sui-table-cell>
            <input readonly v-model="variable.value" tabindex="-1" />
          </sui-table-cell>
          <sui-table-cell collapsing>
            <i class="trash fitted disabled icon" />
          </sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-body v-if="$attrs.value.length">
        <sui-table-row :class="{required: field.fillonly && !variable.filled}" :error="variable.hasError" v-for="(variable, index) in variables" :key="index">
          <sui-table-cell :data-tooltip="variable.changed ? variable.nameError : null" data-inverted>
            <input ref="name" v-model="$attrs.value[index].name" :readonly="field.readonly" :tabindex="field.readonly ? -1 : 0" @focus="onFocus(index, true)" @blur="onFocus(index, false)" @input="onInput()" />
          </sui-table-cell>
          <sui-table-cell :data-tooltip="variable.changed ? variable.valueError : null" data-inverted>
            <div class="env-value">
              <input ref="value" v-model="$attrs.value[index].value" :readonly="variable.isReadonly" :tabindex="variable.isReadonly ? -1 : 0" @focus="onFocus(index, true)" @blur="onFocus(index, false)" @input="onInput()" />
              <span data-inverted data-position="left center" :data-tooltip="tooltips[variable.name]" v-show="tooltips[variable.name]"><i class="help circle blue icon" /></span>
            </div>
          </sui-table-cell>
          <sui-table-cell collapsing>
            <i class="trash fitted icon" :class="{disabled: field.readonly}" @click.prevent="remove(index)" />
          </sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-footer v-if="!field.readonly">
        <sui-table-row>
          <sui-table-header-cell colspan="3">
            <div class="ui tiny left labeled icon button" @click.prevent="add()">
              <i class="plus icon" />
              Add variable
            </div>
          </sui-table-header-cell>
        </sui-table-row>
      </sui-table-footer>
    </sui-table>
  </sui-form-field>
</template>

<script>
  import FormField from '@/mixins/FormField'

  export default {
    name: 'FormServiceEnv',
    mixins: [
      FormField,
    ],
    props: [
      'color',
    ],
    data() {
      return {
        meta: this.$attrs.value.map(variable => {
          return {
            changed: !!variable.value,
            focused: false,
            filled: !!variable.value,
          }
        }),
      }
    },
    computed: {
      variables() {
        return this.$attrs.value.map((variable, index) => {
          const hasNameError = this.error && (this.meta[index].changed || this.$attrs.value[index].name) && this.error[index].name
          const hasValueError = this.error && (this.meta[index].changed || this.$attrs.value[index].value) && this.error[index].value
          return {
            ...variable,
            ...this.meta[index],
            isReadonly: (this.field.readonly && !this.field.fillonly) || (this.field.fillonly && this.meta[index].filled),
            hasError: Boolean(this.error && this.error[index] && (hasNameError || hasValueError)),
            nameError: this.error && this.error[index] ? this.error[index].name : null,
            valueError: this.error && this.error[index] ? this.error[index].value : null,
          }
        })
      },
      tooltips() {
        return this.entity.comments && this.entity.comments.env || {}
      },
    },
    methods: {
      add() {
        this.meta.push({changed: false, focused: false})
        this.$attrs.value.push({name: '', value: ''})
        this.onInput()
        this.$nextTick(() => {
          this.$refs.name[this.$refs.name.length - 1].focus()
        })
      },
      onFocus(index, value) {
        if (this.meta.length) {
          this.meta[index].focused = value
          if (!value) {
            // do not validate new variable after typing the name (if focus is kept)
            setTimeout(() => {
              if (this.meta[index] && !this.meta[index].focused) {
                this.meta[index].changed = true
              }
            }, 100)
          }
        }
      },
      remove(index) {
        this.$attrs.value.splice(index, 1)
        this.meta.splice(index, 1)
        this.onInput()
      },
    },
  }
</script>

<style scoped>
  .table { margin-top: 0!important; }
  .env-value { display: flex; align-items: center; }
  .trash:hover { color: #c00; cursor: pointer; }
  input[readonly] { opacity: .5; }
  [data-tooltip] { margin-left: .5em; }
</style>
